// src/redux/slices/makeReservationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { MakeReservationRequest } from '../../types/tableReservation';

interface MakeReservationState {
  loading: boolean;
  success: boolean;
  reservationData: any;
  error: string | null;
}

const initialState: MakeReservationState = {
  loading: false,
  success: false,
  reservationData: null,
  error: null,
};

export const makeReservationSlice = createSlice({
  name: 'makeReservation',
  initialState,
  reducers: {
    makeReservationRequest: (state, action: PayloadAction<MakeReservationRequest>) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    makeReservationSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = true;
      state.reservationData = action.payload;
      state.error = null;
    },
    makeReservationFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    resetReservationState: (state) => {
      state.loading = false;
      state.success = false;
      state.reservationData = null;
      state.error = null;
    },
  },
});

export const {
  makeReservationRequest,
  makeReservationSuccess,
  makeReservationFailure,
  resetReservationState,
} = makeReservationSlice.actions;

export default makeReservationSlice.reducer;
